import { ReactComponent as EditIcon } from 'assets/images/icon/edit-icon.svg';
import { ReactComponent as ExclamationMarkIcon } from 'assets/images/icon/exclamation-mark-icon.svg';
import { ReactComponent as PlusIcon } from 'assets/images/icon/plus-icon.svg';
import { ReactComponent as SearchIcon } from 'assets/images/icon/search-icon.svg';
import { AddNewUserForm } from 'components/universal/addNewUser';
import { Button } from 'components/universal/button';
import { DeleteUsersForm } from 'components/universal/deleteUsersForm';
import { DownloadCertificateModal } from 'components/universal/downloadCertificateModal';
import { EditUserDataForm } from 'components/universal/editUserDataForm';
import { GenerateLoginForm } from 'components/universal/generateLoginForm';
import Heading from 'components/universal/heading';
import { Modal } from 'components/universal/modal';
import { useEffect } from 'react';
import cls from './employeeManagement.module.scss';
import { useEmployees } from './useEmployees';
import { ReactComponent as Arrow } from 'assets/images/contact/arrow-down.svg';
import { AcceptUserModal } from 'components/universal/acceptUserFormModal';
import { AddNewUserModal } from 'components/universal/addNewUserModal';
import { AddMultipleNewUserForm } from 'components/universal/addMultipleUser';
import CompleteIcon from 'assets/images/icon/complete-icon.svg';
import InCompleteIcon from 'assets/images/icon/incomplete-icon.svg';
import { ReactComponent as ArrowDown } from 'assets/images/icon/arrow-down.svg';

export interface EmployeeElearningAnalytics {
    id: number;
    user_id: number;
    elearning_course_id: number;
    course_is_done: number;
    cert_download_count: number;
    cert_premium_download_count: number;
    created_at: string;
    updated_at: string;
}

export interface employeesInterface {
    email: string;
    employee_position_name?: string;
    first_name: string;
    has_elearning_permission: boolean;
    is_admin: boolean;
    is_premium: boolean;
    last_name: string;
    login: string;
    phone: string;
    workplace_address_city?: string;
    workplace_address_number?: string;
    workplace_address_postcode?: string;
    workplace_address_street?: string;
    workplace_name?: string;
    first_login?: boolean;
    id: number;
    department: string;
    last_login_at: string | null;
    elearning_analitics?: EmployeeElearningAnalytics[];
}

export const EmployeeManagementView = () => {
    const {
        t,
        handleChange,
        showHandle,
        handleCheckboxChange,
        handleToggleAll,
        sendLogins,
        hideModalHandle,
        tooltipRef,
        showTooltip,
        selectedEmployees,
        setShowTooltip,
        searchTerm,
        searchHandle,
        searchRef,
        filteredEmployees,
        generateSingleLoginAndPassword,
        modalType,
        editData,
        deleteUser,
        deleteUsers,
        addNewUserShowPopup,
        adminWorkplaces,
        findWorkplaceId,
        page,
        showMoreEmployees,
        selectedEmployee,
        acceptserShowPopup,
        showFirstLogin, 
        setShowFirstLogin,
        loadMoreIsHide,
        setModalType,
        downloadCertificateModalType,
        selectedCourseIds,
        downloadModalEmployee,
        allCourses,
        coursesLoading,
        coursesError,
        setSelectedCourseIds,
        confirmDownloadCertificateModal,
        cancelDownloadCertificateModal,
        downloadCertificatesAction,
        downloadSingleCertificateAction,
        ellipsis
    } = useEmployees();

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as HTMLElement;

            if (tooltipRef.current && tooltipRef.current.contains(target)) return;

            setShowTooltip(null);
        };

        if (showTooltip !== null) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showTooltip]);

    return (
        <>
            <Modal className={cls.modal}>
                {modalType === 'generateLogin' && (
                    <GenerateLoginForm users={selectedEmployees} onCancel={hideModalHandle} />
                )}
                 {modalType === 'deleteUser' && (
                    <DeleteUsersForm users={selectedEmployees} onCancel={hideModalHandle} />
                )}
                {modalType === 'editData' && (
                    <EditUserDataForm user={selectedEmployees} workplaceId={findWorkplaceId()} onCancel={hideModalHandle} />
                )}
                {modalType === 'addNewUser' && (
                    <AddNewUserModal onCancel={hideModalHandle} setModalType={setModalType} workplaceId={adminWorkplaces[0]?.id} />
                )}
                {modalType === 'addNewUserSingle' && (
                    <AddNewUserForm workplaceId={adminWorkplaces[0]?.id} onCancel={hideModalHandle} />
                )}
                {modalType === 'addNewUserMultiple' && (
                    <AddMultipleNewUserForm adminWorkplaces={adminWorkplaces} onCancel={hideModalHandle} />
                )}
                {modalType === 'acceptUser' && (
                    <AcceptUserModal user={selectedEmployee} onCancel={hideModalHandle} setShowFirstLogin={setShowFirstLogin} />
                )}
                {modalType === 'downloadCertificatesSelect' && (
                    <DownloadCertificateModal
                        downloadCertificateModalType={downloadCertificateModalType}
                        selectedCourseIds={selectedCourseIds}
                        downloadModalEmployee={downloadModalEmployee}
                        allCourses={allCourses}
                        coursesLoading={coursesLoading}
                        coursesError={coursesError}
                        setSelectedCourseIds={setSelectedCourseIds}
                        confirmDownloadCertificateModal={confirmDownloadCertificateModal}
                        cancelDownloadCertificateModal={cancelDownloadCertificateModal}
                    />
                )}
            </Modal>

            <div className={cls.container}>
                <header className={cls.header}>
                    <Heading
                        className={cls.heading}
                        headingLevel="h1"
                        headingStyle="h3"
                    >
                        {t('employeeManagement.title')}
                    </Heading>
                    <div className={cls.searchWrapper}>
                        <a className={cls.buttonSearch} onClick={searchHandle}>
                            <SearchIcon />
                        </a>
                        <input
                            type="text"
                            placeholder={t(
                                'employeeManagement.searchPlaceholder'
                            )}
                            value={searchTerm}
                            onChange={handleChange}
                            className={`${cls.inputSearch} px-4 py-2`}
                            ref={searchRef}
                        />
                        <span className={cls.fakeCheckbox}></span>
                    </div>

                    <div className={cls.headerButtonWrapper}>
                        <Button className={cls.addEmployeeButton} onClick={addNewUserShowPopup}>
                            {t('employeeManagement.addEmployeeLabel')}
                            <PlusIcon />
                        </Button>
                    </div>
                </header>
            </div>
            { filteredEmployees && 
                <div className={cls.listCointainer}>
                    <div className={cls.listWrapper}>
                        <ul className={cls.list}>
                            <li className={cls.item}>
                                <div className={cls.employeeColumnName}>
                                    <div className={cls.checkboxWrapper}>
                                        <input
                                            type="checkbox"
                                            name="employee"
                                            checked={selectedEmployees.length > 0 ? true : false}
                                            onChange={handleToggleAll}
                                            className={`${cls.checkbox} ${cls.first} ${selectedEmployees.length === filteredEmployees.length && cls.all}`}
                                        />
                                        <span className={cls.fakeCheckbox}></span>
                                    </div>
                                    <h3>{t('employeeManagement.nameLabel')}</h3>
                                </div>
                                <h3 className={cls.employeeColumnLogin}>
                                    {t('employeeManagement.loginLabel')}
                                </h3>
                                <h3 className={cls.employeeDepartment}>
                                    {t('employeeManagement.department')}
                                </h3>
                                <h3 className={cls.rowTime}>
                                    {t('employeeManagement.lastLoginLabel')}
                                </h3>
                                <h3 className={cls.rowCourse}>
                                    HI
                                    <p className={cls.rowCourseHover}>{t('employeeManagement.courseLabel')}: Higiena Rąk</p>
                                </h3>
                                <h3 className={cls.employeeColumnEdit}>
                                    {selectedEmployees.length > 0 && (
                                       <>
                                            <Button className={`${cls.editButton} ${showTooltip === 'header' ? cls.activeOption : ''}`} styleType="blue" onClick={() => showHandle('header')}>
                                                {t('employeeManagement.optionLabel')} <ArrowDown />
                                            </Button>
                                            <div 
                                                ref={showTooltip === 'header' ? tooltipRef : null}
                                                className={`${cls.tooltipButtons} ${showTooltip === 'header' ? cls.active : ''}`}
                                            > 
                                                <a
                                                    className={cls.headerButton}
                                                    onClick={sendLogins}
                                                >
                                                    {t('employeeManagement.sendLoginLabel')}
                                                </a>
                                                <a
                                                    className={cls.headerButton}
                                                    onClick={deleteUsers}
                                                >
                                                    {t('employeeManagement.delete')}
                                                </a>
                                                <a
                                                    className={cls.headerButton}
                                                    onClick={downloadCertificatesAction}
                                                >
                                                    {t('employeeManagement.downloadCertificatesLabel')}
                                                </a>
                                            </div>
                                       </>
                                    )}
                                </h3>
                            </li>
                            {filteredEmployees.length > 0 ? (
                                filteredEmployees.map( (employee, key) => (
                                    <li key={employee.id} className={cls.item} data-id={employee.id}>
                                        <div className={cls.employeeColumnName}>
                                            <div className={cls.checkboxWrapper}>
                                                <input
                                                    type="checkbox"
                                                    name="employee"
                                                    className={cls.checkbox}
                                                    checked={selectedEmployees.some(e => e.id === employee.id)}
                                                    onChange={() => handleCheckboxChange(employee)}
                                                />
                                                <span
                                                    className={cls.fakeCheckbox}
                                                ></span>
                                            </div>
                                            <p>{ellipsis(`${employee.first_name || '-'} ${employee.last_name || '-'}`, 14)}</p>
                                        </div>
                                        <p className={`${cls.employeeColumnLogin} ${(!employee.login || !employee.email) && cls.empty}`}>
                                            { ellipsis(employee.login || employee.email, 10) || <ExclamationMarkIcon /> }
                                        </p>
                                        <p className={cls.employeeDepartment}>
                                            {employee.department}
                                        </p>
                                        <p className={`${cls.rowTime} ${!employee.last_login_at ? cls.danger : cls.time}`}>
                                            {employee.last_login_at
                                                ? new Date(employee.last_login_at).toLocaleDateString()
                                                : t('employeeManagement.neverLoggedInLabel')}
                                        </p>
                                        <p className={cls.rowCourse}>
                                            <img src={key % 2 === 0 ? CompleteIcon : InCompleteIcon} alt={employee.has_elearning_permission ? 'complete' : 'incomplete'} />
                                        </p>
                                        <div className={cls.employeeColumnEdit}>
                                            {(employee.first_login && showFirstLogin) && (
                                                <a 
                                                    className={cls.firstLoginWrapper} 
                                                    onClick={() => acceptserShowPopup(employee)}
                                                    >
                                                    <span className={cls.firstLoginLabel}>
                                                        {t('employeeManagement.firstLoginLabel')}
                                                    </span>
                                                </a>
                                            )}
                                            <div 
                                                ref={showTooltip === employee.id ? tooltipRef : null}
                                                className={`${cls.tooltipButtons} ${showTooltip === employee.id && cls.active}`}
                                                > 
                                                <a onClick={() => generateSingleLoginAndPassword(employee)}>{t('employeeManagement.generateLoginAndPasswordLabel')}</a>
                                                <a onClick={() => editData(employee)}>{t('employeeManagement.editDataLabel')}</a>
                                                <a onClick={() => deleteUser(employee)}>{t('employeeManagement.deleteEmployeeLabel')}</a>
                                                <a onClick={() => downloadSingleCertificateAction(employee)}>{t('employeeManagement.downloadCertificateLabel')}</a>
                                            </div>
                                            <button onClick={() => showHandle(employee.id)}>
                                                <EditIcon />
                                            </button>
                                        </div>
                                    </li>
                                ))
                            ) : (
                                <li className={`${cls.item} ${cls.itemLast}`}>
                                    {t('employeeManagement.noEmployessLabel')}
                                </li>
                            )}
                        </ul>
                    </div>
                    {!loadMoreIsHide && <a className={cls.loadMore} onClick={showMoreEmployees}>{t('employeeManagement.loadMore')} <Arrow /></a>}
                </div>
            }
        </>
    );
};
